import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { PlusIcon } from '@radix-ui/react-icons';
import upperFirst from 'lodash/upperFirst';
import { IconButton } from '@producer/ui-kit';

import { TagItem } from './tag-item';
import { Tag, TagTarget } from '../../../app/entities/tag';
import { Tooltip } from '../../../components/tooltip/Tooltip';
import { Left, Strip, Wrapper } from './styled-tags-components';
import { CreateTagModal } from './create-tag.modal';

import styles from './tag-collection.module.scss';
type TagCollectionProps = {
  target: TagTarget;
  tags: Tag[];
  defaultValue: object;
};

export const TagCollection: React.FC<TagCollectionProps> = observer(({ target, tags }) => {
  const [createModalIsOpen, setCreateModalIsOpen] = useState(false);

  const getTargetTitle = (target: TagTarget) => `${upperFirst(target)} tags`;

  return (
    <>
      <Strip data-header="true">
        <Left>
          <span className={styles['status-title']}>{getTargetTitle(target)}</span>

          <span className={styles['count']}>{tags.length}</span>
        </Left>

        <Tooltip text="Create new tag">
          <Wrapper>
            <IconButton
              variant="x-dark"
              icon={<PlusIcon />}
              onClick={() => setCreateModalIsOpen(true)}
            />
          </Wrapper>
        </Tooltip>
      </Strip>

      {tags.map((tag) => (
        <TagItem key={tag._id} tag={tag} />
      ))}

      {createModalIsOpen && (
        <CreateTagModal onCancel={() => setCreateModalIsOpen(false)} target={target} />
      )}
    </>
  );
});
